import jMoment from 'moment-jalaali';
import React from 'react';
import { transformLogo } from '../../utils/helpers';

export const baseHead = [
  {
    head: 'شناسه سفارش',
    id: 'id',
  },
  {
    head: 'آدرس',
    id: 'customerAddress',
  },
  {
    head: 'مرکز انبار',
    id: 'centerName',
  },
  {
    head: 'شرکت',
    id: 'partnerName',
  },
  {
    head: 'تاریخ تحویل',
    id: 'deliveryDate',
    body: (row: any) => {
      return `${jMoment(
        row.deliveryDate,
        'YYYY/MM/DD'
      )
        .locale('fa')
        .format('jYYYY/jMM/jDD')}`
    }
  },
  {
    head: 'زمان تحویل',
    id: 'deliveryTime',
    body: (row: any) => {
      return `${jMoment(row.deliveryStartTime, 'hh:mm:ss').locale('fa').format('HH:mm')}
      -
      ${jMoment(row.deliveryEndTime, 'hh:mm:ss').locale('fa').format('HH:mm')}`
    }
  },
  {
    head: 'وزن(کیلوگرم)',
    id: 'weight',
    body: (row: any) => row.orderPackages[0] && row.orderPackages[0].totalWeight
  },
  {
    head: 'ابعاد(سانتی‌متر)',
    id: 'size',
    body: (row: any) => row.orderPackages[0] && `${row.orderPackages[0].length}×${row.orderPackages[0].width}×${row.orderPackages[0].height}`
  },
  {
    head: 'پیغام',
    id: 'errorOfSuggestion',
    body: (row: any) => (<p className='text-error'>{row?.errorOfSuggestion}</p>)
  },
];

export const approvedHead = [
  {
    head: 'شناسه سفارش',
    id: 'id',
  },
  {
    head: 'آدرس',
    id: 'customerAddress',
  },
  {
    head: 'مرکز انبار',
    id: 'centerName',
  },
  {
    head: 'شرکت',
    id: 'partnerName',
  },
  {
    head: 'تاریخ تحویل',
    id: 'deliveryDate',
    body: (row: any) => {
      return `${jMoment(
        row.deliveryDate,
        'YYYY/MM/DD'
      )
        .locale('fa')
        .format('jYYYY/jMM/jDD')}`
    }
  },
  {
    head: 'زمان تحویل',
    id: 'deliveryTime',
    body: (row: any) => {
      return `${jMoment(row.deliveryStartTime, 'hh:mm:ss').locale('fa').format('HH:mm')}
      -
      ${jMoment(row.deliveryEndTime, 'hh:mm:ss').locale('fa').format('HH:mm')}`
    }
  },
  {
    head: 'وزن(کیلوگرم)',
    id: 'weight',
    body: (row: any) => row.orderPackages[0] && row.orderPackages[0].totalWeight
  },
  {
    head: 'ابعاد(سانتی‌متر)',
    id: 'size',
    body: (row: any) => row.orderPackages[0] && `${row.orderPackages[0].length}×${row.orderPackages[0].width}×${row.orderPackages[0].height}`
  },
];

export const reportHead = [
  {
    head: 'شناسه سفارش',
    id: 'orderId',
  },
  {
    head: 'پیغام',
    id: 'errorMessage',
    body: (row: any) => (<p className='text-error'>{row?.errorMessage}</p>)
  },
  {
    head: 'کوریر',
    id: 'tplCode',
    body: (row: any) => (<img src={transformLogo(row.tplCode)} width="40px" height="40px" />)
  },
];
